
import { defineComponent } from 'vue';
import DefaultHeader from '../components/header/DefaultHeader.vue';

export default defineComponent({
  components: { DefaultHeader },
});
